import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { ModalWrapperProps } from '.';
import { Modal } from '@mantine/core';
import { FiX } from 'react-icons/fi';
import { useMediaQuery } from '@mantine/hooks';

const ModalWrapper: React.FC<ModalWrapperProps> = ({
  isVisible,
  onClose,
  title,
  size = 'lg',
  withCloseButton = true,
  children
}) => {
  const smScreen = useMediaQuery('(max-width: 48em)');
  return (
    <Modal
      opened={isVisible}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      onClose={onClose}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3
      }}
      padding={smScreen ? 16 : 36}
      radius={smScreen ? 12 : 16}
      size={size}
      withCloseButton={false}
      // zIndex={999992}
    >
      <div className="modal-wrapper__title">
        <h2>{title}</h2>
        {withCloseButton && (
          <div className="modal-wrapper__close-button" onClick={onClose}>
            <FiX />
          </div>
        )}
      </div>
      {children}
    </Modal>
  );
};

export default ModalWrapper;
